import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateEventReminderService, type ReminderPayload } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useUpdateEventReminder = (agendaId: string, eventId: string, reminderId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: ReminderPayload) => updateEventReminderService(agendaId, eventId, reminderId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
